import React from 'react';

class NavigationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Only catch navigation-related errors
    const isNavigationError = 
      error.message?.includes('navigation') ||
      error.message?.includes('AnimatePresence') ||
      error.message?.includes('framer-motion') ||
      error.message?.includes('history') ||
      error.message?.includes('popstate') ||
      error.message?.includes('route') ||
      error.message?.includes('router');

    if (isNavigationError) {
      console.warn('Navigation error caught by NavigationErrorBoundary:', error.message);
      return { hasError: true, error };
    }
    
    // Re-throw non-navigation errors
    throw error;
  }

  componentDidCatch(error, errorInfo) {
    console.warn('Navigation error caught:', error.message);
    
    // Try to recover from navigation errors
    setTimeout(() => {
      this.setState({ hasError: false, error: null });
    }, 100);
  }

  render() {
    if (this.state.hasError) {
      // Show a minimal error state for navigation errors
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <div className="text-2xl mb-2">🔄</div>
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default NavigationErrorBoundary; 